// extracted by mini-css-extract-plugin
export default {"root":"Panel_root__Fn8Hn"};